import { parse } from 'date-fns';
import { tz } from '@date-fns/tz';
import type { YearEndFlashSaleRotation } from '../../constants/campaign/yearEndFlashSale';
import {
  YEAR_END_FLASH_SALE_ROTATIONS,
  YEAR_END_FLASH_SALE_TIMEZONE,
} from '../../constants/campaign/yearEndFlashSale';

/**
 * Checks if the current time falls within a rotation's time range
 *
 * @param rotation The rotation to check
 * @param now The current date/time
 * @param pattern Date parse pattern
 * @returns true if rotation is active, false otherwise
 */
const isRotationActive = (rotation: YearEndFlashSaleRotation, now: Date, pattern: string): boolean => {
  const startDateTime = parse(rotation.startDate, pattern, new Date(), { in: tz(YEAR_END_FLASH_SALE_TIMEZONE) });
  const endDateTime = parse(rotation.endDate, pattern, new Date(), { in: tz(YEAR_END_FLASH_SALE_TIMEZONE) });

  return now >= startDateTime && now < endDateTime;
};

/**
 * Gets the active Year End Flash Sale rotation based on current time in SGT
 *
 * @param pattern Optional custom date-fns parse pattern. Defaults to 'yyyy-MM-dd HH:mm:ss'
 * @returns The active rotation if found, null otherwise
 */
export const getActiveYearEndFlashSaleRotation = (
  pattern = 'yyyy-MM-dd HH:mm:ss',
): YearEndFlashSaleRotation | null => {
  const now = new Date();

  return YEAR_END_FLASH_SALE_ROTATIONS.find((rotation) => isRotationActive(rotation, now, pattern)) ?? null;
};

